export default {
    /* GET_DETAILED_USER_REPORTS
    ---------------------------------------------------------------
    */
    GET_DETAILED_USER_REPORTS_REQUEST: state => {
        state.reportsLoading = true
    },
    GET_DETAILED_USER_REPORTS_SUCCESS: (state, data) => {
        state.detailedReports = data.results
        state.reportsLoading = false
    },
    GET_DETAILED_USER_REPORTS_FAILURE: state => {
        state.reportsLoading = false
    },

    GET_WORKSPACES_SUCCESS: (state, data) => {
        state.workspaces = data.results
    },

    SET_REPORT_SETTINGS: (state, data) => {
        state.reportSettings = data
        state.hasReportSettings = true
    },

    CLEAR_REPORT_SETTINGS: state => {
        state.reportSettings = {
            machine: null,
            process: null,
            workspace: null
        }
        state.hasReportSettings = false
    },

    SET_MACHINE_PROCESSES: (state, data) => {
        state.machineProcesses = data
    },

    START_REPORTING_SESSION: (state) => {
        state.detailedReports = []
    },
    GET_REPORT_OUT_OF_SEQUENCE_CODES: (state, data) => {
        state.reportOutOfSequenceCodes = data.results
    },
    GET_WORKSPACE_SUCCESS: (state, data) => {
        state.reportSettings.workspace = data
    },
    SET_REPORT_ITEM_ORDERS_FILTERS: (state, filters) => {
        state.reportItemOrdersFilters = filters
    },
    CLEAR_REPORT_ITEM_ORDERS_FILTERS: state => {
        state.reportItemOrdersFilters = state.setInitialReportItemOrdersFilters()
    },
    GET_SHIPPING_GROUPS: (state, data) => {
        state.shippingGroups = data.results
    },
    GET_PLATE_ORDER_REASONS: (state, data) => {
        state.plateOrderReasons = data.results
    }
}
